<template>
  <div>
    <CustomShape />
    <div class="lg:flex bg-customgray">
      <div class="flex-1 text-gray-700 p-4">
        <button
          class="bg-gray-600 uppercase py-1 px-2 w-full text-white hover:bg-gray-700 rounded mb-4 mt-2 relative"
          @click="handleBackgroundToggle"
        >
          Background
          <FontAwesomeIcon
            :icon="backgroundIsActive ? 'minus-circle' : 'plus-circle'"
            class="absolute right-iconright top-icontop"
          />
        </button>
        <ImagePicker v-if="backgroundIsActive" />
      </div>
      <div class="flex-1 text-gray-700 p-4">
        <button
          class="bg-gray-600 uppercase py-1 px-2 w-full text-white hover:bg-gray-700 rounded mb-2 mt-2 relative"
          @click="handleHeaderToggle"
        >
          Header
          <FontAwesomeIcon
            :icon="headerIsActive ? 'minus-circle' : 'plus-circle'"
            class="absolute right-iconright top-icontop"
          />
        </button>
        <div v-if="headerIsActive">
          <input
            id="inline-full-name"
            v-model="header"
            type="text"
            size="18"
            class="appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline mt-2"
            placeholder="Header text..."
          />
          <HeaderFontPicker />
        </div>
      </div>
      <div class="flex-1 text-gray-700 p-4">
        <button
          class="bg-gray-600 uppercase py-1 px-2 w-full text-white hover:bg-gray-700 rounded mb-2 mt-2 relative"
          @click="handleTextToggle"
        >
          Text
          <FontAwesomeIcon
            :icon="textIsActive ? 'minus-circle' : 'plus-circle'"
            class="absolute right-iconright top-icontop"
          />
        </button>
        <div v-if="textIsActive">
          <textarea
            v-model="body"
            rows="1"
            cols="18"
            class="appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline mt-2 min-h-10"
            placeholder="Text..."
          />
          <BodyFontPicker />
        </div>
      </div>

      <div class="flex-1 text-gray-700 p-4">
        <button
          class="bg-gray-600 uppercase py-1 px-2 w-full text-white hover:bg-gray-700 rounded mb-2 mt-2 relative"
          @click="handleButtonToggle"
        >
          Button
          <FontAwesomeIcon
            :icon="buttonIsActive ? 'minus-circle' : 'plus-circle'"
            class="absolute right-iconright top-icontop"
          />
        </button>
        <div v-if="buttonIsActive">
          <input
            v-model="button"
            type="text"
            size="18"
            class="appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline mt-2"
            placeholder="Button text..."
          />
          <ButtonDesigner />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ImagePicker from '@/components/ImagePicker.vue'
import HeaderFontPicker from '@/components/HeaderFontPicker.vue'
import BodyFontPicker from '@/components/BodyFontPicker.vue'
import ButtonDesigner from '@/components/ButtonDesigner.vue'
import CustomShape from '@/components/CustomShape.vue'
export default {
  name: 'ControlPanel',
  components: {
    ImagePicker,
    HeaderFontPicker,
    BodyFontPicker,
    ButtonDesigner,
    CustomShape
  },
  props: {},
  emits: ['button-status'],
  data() {
    return {
      buttonIsActive: false,
      backgroundIsActive: false,
      headerIsActive: false,
      textIsActive: false
    }
  },
  computed: {
    header: {
      get() {
        return this.$store.state.headerText
      },
      set(value) {
        this.$store.commit('updateHeader', value)
      }
    },
    body: {
      get() {
        return this.$store.state.bodyText
      },
      set(value) {
        this.$store.commit('updateBody', value)
      }
    },
    button: {
      get() {
        return this.$store.state.buttonText
      },
      set(value) {
        this.$store.commit('updateButton', value)
      }
    }
  },
  methods: {
    handleButtonToggle() {
      this.buttonIsActive = !this.buttonIsActive
      this.$emit('button-status', this.buttonIsActive)
    },
    handleBackgroundToggle() {
      this.backgroundIsActive = !this.backgroundIsActive
    },
    handleHeaderToggle() {
      this.headerIsActive = !this.headerIsActive
    },
    handleTextToggle() {
      this.textIsActive = !this.textIsActive
    }
  }
}
</script>

<style scoped>
/* No animations needed */
</style>
